const c = {
  name: "Usb",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M26.7,12L20,0l-6.7,12H19v14c-0.8-0.6-1.9-1-3-1H9c-1.7,0-3-1.3-3-3v-0.1c2.3-0.5,4-2.5,4-4.9
			c0-2.8-2.2-5-5-5c-2.8,0-5,2.2-5,5c0,2.4,1.7,4.4,4,4.9V22c0,2.8,2.2,5,5,5h7c1.7,0,3,1.3,3,3v0.1c-2.3,0.5-4,2.5-4,4.9
			c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5c0-2.4-1.7-4.4-4-4.9V26c0-1.7,1.3-3,3-3h7c2.8,0,5-2.2,5-5h4V8H30v10h4c0,1.7-1.3,3-3,3h-7
			c-1.1,0-2.2,0.4-3,1V12H26.7z M23.3,10h-6.6L20,4.1L23.3,10z M32,16v-6h6v6H32z M2,17c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3s-1.3,3-3,3
			C3.3,20,2,18.7,2,17z M20,32c1.7,0,3,1.3,3,3s-1.3,3-3,3c-1.7,0-3-1.3-3-3S18.3,32,20,32z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Usb
};
